import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import CollegeExchangeSteps from '../CollegeExchangeSteps/CollegeExchangeSteps';
import { moduleActions } from '../../../redux/modules';
import {
  getCollegePlanType,
  getCollegeTypeCount,
} from '../../../redux/modules/productTypes/productType.selectors';
import { constructExchangeEmail } from '../../../redux/modules/user/Communication/userCommunication.selectors';
import {
  isCustomerWebViewEnabled,
  isEmbeddedInIFrame,
  isSalesforceRep,
} from '../../../redux/modules/authentication/authentication.module.selectors';
import {
  didPersonalInformationFail,
  getDateOfBirth,
  getIsAddressAvailable,
  getIsNotForeignAddress,
} from '../../../redux/modules/user/PersonalInformation/personalInformation.selectors';
import {
  ADDRESS_INCOMPLETE,
  APP_FAILURE,
  DOB_FAILURE,
  EXCHANGE_TO_EXISTING_LOAD_FAILED,
  FOREIGN_ADDRESS,
  executingCollegeExchangeMessages,
  loadingExchangeCollegeMessages,
  NOT_RETAIL_CLIENT,
  MD529_DECOMMISSION,
} from '../../../settings/settings';
import BalancesAsOfToolTip from '../../Shared/BalancesAsOfToolTip/BalancesAsOfToolTip';
import CollegeBrandingContainer from '../../Shared/CollegeBrandingContainer/CollegeBrandingContainer';
import FullPageLoader from '../../Shared/FullPageLoader/FullPageLoader';
import StepsPageBackground from '../../Shared/StepsPageBackground/StepsPageBackground';
import { appendBasePath } from '../../../utils/nav.utils';
import { hasValue } from '../../../utils/utils';
import If from '../../Shared/If/If';

export class CollegeExchangeLanding extends Component {
  componentDidUpdate(prevProps) {
    this.checkNeedPushConfirm(prevProps);
  }

  checkNeedPushConfirm(prevProps) {
    const {
      actions: { sendConfirmationEmail },
      executeExchange: { isLoaded, transactions },
      history,
    } = this.props;
    const {
      executeExchange: { isLoading: wasLoading },
    } = prevProps;

    if (wasLoading && isLoaded && hasValue(transactions)) {
      sendConfirmationEmail(constructExchangeEmail(transactions));
      history.push(appendBasePath('/college/exchange/confirm'));
    }
  }

  render() {
    const {
      isIFrame,
      customerWebViewEnabled,
      isSalesforceRep,
      applicationData,
      dateOfBirth,
      hasMD529OnlyCount,
      personalInfoFailed,
      executeExchange,
      exchangeTransaction,
      isAddressAvailable,
      isNotForeignAddress,
      isCorporateAccountType,
      IRALimit,
      personalInformation: { data: personalData },
    } = this.props;
    const isLoaderVisible =
      applicationData.isLoading || executeExchange.isLoading;
    const { retailEnabled } = personalData;
    const message = applicationData.isLoading
      ? loadingExchangeCollegeMessages
      : executeExchange.isLoading
      ? executingCollegeExchangeMessages
      : '';
    const getError = () => {
      if (!personalInfoFailed && !dateOfBirth && !isCorporateAccountType) {
        return {
          type: DOB_FAILURE,
          hasError: true,
        };
      }
      if (!personalInfoFailed && !isNotForeignAddress) {
        return {
          type: FOREIGN_ADDRESS,
          hasError: true,
        };
      }
      if (
        applicationData.hasFailed ||
        (IRALimit.hasFailed && !isCorporateAccountType)
      ) {
        return {
          type: APP_FAILURE,
          hasError: true,
        };
      }
      if (exchangeTransaction.exchangeToExistingLoadFailed) {
        return {
          type: EXCHANGE_TO_EXISTING_LOAD_FAILED,
          hasError: true,
        };
      }
      if (!retailEnabled) {
        return {
          type: NOT_RETAIL_CLIENT,
          hasError: true,
        };
      }
      if (!isAddressAvailable) {
        return {
          type: ADDRESS_INCOMPLETE,
          hasError: true,
        };
      }
      if (hasMD529OnlyCount === 0) {
        return {
          type: MD529_DECOMMISSION,
          hasError: true,
        };
      }
      return {
        type: '',
        hasError: false,
      };
    };
    return (
      <CollegeBrandingContainer>
        <FullPageLoader
          isVisible={isLoaderVisible}
          hasError={getError().hasError}
          errorType={getError().type}
          messages={message}
        />
        <If test={!(isIFrame || (!customerWebViewEnabled && isSalesforceRep))}>
          <StepsPageBackground />
        </If>
        <div className="container">
          <CollegeExchangeSteps />
          <BalancesAsOfToolTip />
          <hr />
          <p style={{ margin: '10px 0' }}>2754810</p>
        </div>
      </CollegeBrandingContainer>
    );
  }
}

const mapStateToProps = (state) => {
  const { applicationData, exchangeTransaction, executeExchange } = state;
  return {
    isIFrame: isEmbeddedInIFrame(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    isSalesforceRep: isSalesforceRep(state),
    applicationData,
    collegePlanType: getCollegePlanType(state),
    dateOfBirth: getDateOfBirth(state),
    hasMD529OnlyCount: getCollegeTypeCount(state),
    personalInfoFailed: didPersonalInformationFail(state),
    exchangeTransaction,
    executeExchange,
    isAddressAvailable: getIsAddressAvailable(state),
    isNotForeignAddress: getIsNotForeignAddress(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(CollegeExchangeLanding);
